const themeReducer = (state, action) => {
    if(action.type === 'light-theme') {
        return {...state, theme: 'light-theme'}
    }
    if(action.type === 'dark-theme') {
        return {...state, theme: 'dark-theme'}
    }
    return state;
}

export default themeReducer